import { Outlet, useLocation } from "react-router-dom";

import { SettingSideBar } from "components";

export default function Page() {
    const location = useLocation();
    const isSettingRoot = location.pathname === "/setting";

    return (
        <div className="mobile:pb-[56px]">
            {isSettingRoot ? (
                <SettingSideBar />
            ) : (
                <Outlet />
            )}
        </div>
    );
}